import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { COOKIES_NAMES, getActiveCartId, getActiveUserId, removeCookie } from '../../../helpers';
import { DeleteCartProps } from '@vsf-enterprise/sapcc-api';
import { Context } from '@vue-storefront/core';

export async function clearCart(
  context: Context,
  currentCart: Cart,
  useCartId?: string
): Promise<void> {
  const {
    $sapcc: {
      config: { $cookies }
    }
  } = context;

  const props: DeleteCartProps = {
    cartId: getActiveCartId({ cookies: $cookies, currentCart }),
    userId: getActiveUserId($cookies)
  };

  await context.$sapcc.api.deleteCart(props);

  removeCookie({ cookies: $cookies, name: `${COOKIES_NAMES.CART_ID}-${useCartId}` });
}
